import { useMemo } from 'react';

import { useQuery } from '@apollo/client';

import useConfig from 'UI/customHooks/useConfig';
import { clientLogger } from 'UI/lib';

import { graphql } from 'GQL/gql';

const useMembersSkillProfile = ({ personId }) => {
  const config = useConfig();
  const skillSynonymPoliciesPreset =
    config.cms?.components?.MemberSkillsProfile?.skillSynonymPoliciesPreset;

  const { data, loading: isLoading } = useQuery(
    graphql(`
      query GET_MEMBER_SKILLS_PROFILE($personId: ID!, $policiesPreset: PoliciesPresetInput) {
        user(personId: $personId) {
          profile {
            name
          }
          skills {
            ...userSkillFields
          }
        }
      }
    `),
    {
      variables: {
        personId,
        policiesPreset: { preset: skillSynonymPoliciesPreset, params: { personId } },
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
      onError: error => {
        clientLogger.error(`useMembersSkillProfile - ${error.message}`, error);
      },
    }
  );

  const skillsWithSynonyms = useMemo(
    () => data?.user?.skills.filter(userSkill => userSkill.skill?.synonym),
    [data]
  );

  return {
    isLoading,
    skills: skillsWithSynonyms,
    userName: data?.user?.profile?.name,
  };
};

export default useMembersSkillProfile;
